(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/react-help-utils/assets/javascripts/create-store.js') >= 0) return;  svs.modules.push('/components/utils/react-help-utils/assets/javascripts/create-store.js');
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


(function (svs) {
  var _RTK = RTK,
    createStore = _RTK.createStore,
    combineReducers = _RTK.combineReducers,
    applyMiddleware = _RTK.applyMiddleware,
    compose = _RTK.compose;
  var composeEnhancers = compose;

  if (svs.core.config.data.svsconfig.env !== 'production') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }
  svs.utils.reactHelpUtils.createStore = function (reducers) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var middleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var reducer;
    var enhancer = applyMiddleware.apply(void 0, [ReduxThunk.default].concat(_toConsumableArray(middleware)));
    if (typeof reducers === 'function') {
      reducer = reducers;
    } else {
      reducer = combineReducers(reducers);
    }
    var store = createStore(reducer, initialState, composeEnhancers(enhancer));

    svs.utils.reactHelpUtils.store = store;
    return store;
  };
})(svs);

 })(window);